import React from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NuDropdown  from "../../components/nubox/NuDropdown";
import  NuInput from "components/nubox/NuInput";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

//type:'numeric'

const cbo=[
  {  value:'1', label: 'label1'},
  
]


const formInitial = {
  idd:0,
  ope:'n',
  id_citaho:0,
  hora:	'',
  id_u: 0,
};
//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
//-- la parte de mostrar y ocultar el modal, es manejada externamente
class ModalCitaHora extends React.Component {
  //---- context API
  static contextType  = StoreContext;

  state = {
    modalInsertar:false,
    id_u:0,

    form0: formInitial,

    medicos:[],
    horas:[],
  };
  
  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount Modal");
    //--limpiamos el array de prueba
    this.setState({data:[]});

    this.cargar_medicos();
    //----------- -------------
    //context API
    const [ store, dispatch ] = this.context;
    const {user, paciente} = store;
    
    this.setState({id_u: user.id_u })
    //---------si viene la propiedad true, mostramos la informacion
    this.limpiar( user.id_u );

  }
  //------------------------------------------------------
  limpiar = ( id_u ) =>{
    this.setState({
      form0: {
        ...formInitial,
        id_u: id_u,
      }
    });
  }
  //------------ cambiamos la fecha
  /*handleChangeFechai=(event)=> {    
    this.setState({fechai: event.target.value}); 
  }*/
  //----------------especial, actualiza valores del form -------------------------------
  handleChange = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeForm0 = (e) => {
    //requerimos la prop name="?" en cada control
    //console.log(e.target.name);
    //console.log(e.target.value);

    this.setState({
      form0: {
        ...this.state.form0,
        [e.target.name]: e.target.value,
      },
    });

  };
  //======================================================
  //======================================================
  showModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: true});
  }
  closeModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: false});
  }
  asigna_form01_val=(name,value)=>{
    this.setState({
      form0: {
        ...this.state.form0,
        name: value,
      },
    });
  }
  //---------------
  nuevo =() =>{
    console.log('nuevo');
    this.limpiar();
    
    this.setState({
      form0: {
        ...this.state.form0,
        id: 0,
        ope:'n',
        id_u: this.state.id_u
      },
      modalInsertar: true,
    });
  }
  //---------------
  editar =(idd)=>{
    console.log('editar');
    let param = { 
      idd: idd,
      ope:'f'
    }
    
    axios2.post("citahora_store", param).then(res => {
      console.log(res);
        if(res.data !== null){ 
            
            
            //---asignamos los valores
            this.setState({
              form0: {
                ...res.data,
                "idd": idd,
                "ope": 'e',
              },
              modalInsertar: true, /* show modal */
            });

            //----
        }else{
          toast.error("No existen datos");
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  }

  eliminar =(idd)=>{
    console.log("eliminar");
    let param = { 
      idd: idd,
      ope:'x'
    }
    //console.log(param);
    axios2.post( "citahora_store", param).then(res => {
      console.log(res.data);

        if(res.data.exito===1){ 
            
            this.limpiar();
            this.closeModal();
            toast.success("Eliminado con exito");
            this.props.okModal(); //callback
        }else{
          toast.error("Error al eliminar registro", {
            position: toast.POSITION.TOP_RIGHT
          });
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  }
  //----cargamos los datos desde la base de datos
  cargar_medicos = async() => {
    let param = { 
    }
    
    await axios2.post( "cbo_medicos", param).then(res => {
        if(res.data.length>0){ 
            //NotificationManager.success("Correcto");
            this.setState({medicos: res.data});
            //console.log(this.state.medicos);
            
        }else{
          toast.error("No existen datos");
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
 
 

  validar = () =>{
    if( this.state.form0.id_espe===0){
      toast.error( "Especialidad no valido", {position: toast.POSITION.TOP_RIGHT});
      return true;
    }
  }
  //-------------------------------------
  formSave = () => {
    // the item selected
    console.log("save");

    let error = this.validar();
    if(error==true){
      return;
    }
    
    let param = {...this.state.form0,  };
    console.log("formSave");
    console.log (param);
    axios2.post( "citahora_store", param).then(res => {
        let response = res.data;

        if(response.exito===1){ 
            
          toast.success( response.mensaje, {position: toast.POSITION.TOP_RIGHT});
          //---llamamos a la funcion externa
          this.props.okModal();
          this.closeModal();
        }else{

          toast.error( response.mensaje, {position: toast.POSITION.TOP_RIGHT});
        }

    }).catch(error => {
        //if(error.response.status && error.response.status===400)
        alert("Bad Request");
        console.log(error);
        
    });

  }
  
  render() {
    
    return (
      <div>
        <ToastContainer />
        
        {/*--- modal---- */}
        <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
          <ModalHeader toggle={this.closeModal} 
            className= { (this.state.form0.ope==='n'? "header-verde":"header-naranja") + " " + (this.state.form0.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
          >
            <h4 className="modal-title">
            { this.state.form0.ope==='n'
              ? "Nuevo"
              : "Editar"
            }
            </h4>
          </ModalHeader>

          <ModalBody style={{background: "#F7F7F7"}}>
            { JSON.stringify(this.state.form0) }
            <form  method='POST'>

              <div className="row">
                <div className="col-md-8">
                  <div className='form-group row'>  
                    <label htmlFor='id_cita' className='col-md-4 control-label'><b>Cod. hora</b></label>
                    <div className='col-md-4'>
                        <input 
                          name='id_citaho' 
                          type='text' 
                          className='form-control' 
                          value={this.state.form0.id_citaho} 
                          onChange={ this.handleChangeForm0} readOnly />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label className="control-label">Hora:</label>
                      <NuInput                        
                        className=" form-control" 
                        name="hora" 
                        value={this.state.form0.hora}
                        onChange={this.handleChangeForm0}
                        classOK=""
                        classError="is-invalid"
                        valtipo="hour"
                      />
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label className="control-label">Medico:
                      <span id=""></span>
                    </label>

                    <NuDropdown
                        options={this.state.medicos}                        
                        name="id_u"
                        value={this.state.form0.id_u}
                        onChange={this.handleChangeForm0}
                        readOnly
                    />
                    
                    
                  </div>
                </div>  
              </div>

              

            </form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={ this.formSave}>Guardar</Button>{' '}
            <Button color="secondary" onClick={this.closeModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
  
//------------
export default ModalCitaHora;